import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {ApplicationState, ConnectedReduxProps} from '@reducers/index'
import {Menu} from '@models/menu'
import {deleteRequest, fetchRequest} from '@actions/menu'
import MenuForm from "@components/menus/Form";
import {createRequest, updateRequest} from '@actions/menu';
import menuApi from '@api/menu'
import {injectIntl} from 'react-intl';


interface PropsFromState {
  loading: boolean
  data: Menu[]
  errors?: string,
  count: number
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  deleteRequest: typeof deleteRequest
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps


class MenuFormPage extends React.Component<AllProps> {
  
  state = {
    menu : null,
    menu_id : this.props.match.params.id,
    is_fetched : false
  };
  
  componentDidMount(){
    if(this.state.menu_id){
      this.fetchItem();
    }
  }
  
  fetchItem = () => {
    menuApi.getItem({
        params: {
          id: this.state.menu_id,
        }
      })
      .then(({data}) => {
        this.setState({
          menu : data
        })
      })
      .catch((error) => console.log(error))
  };
  
  getContent = () => {
    if(this.state.menu_id && !this.state.menu){
      return null
    }
    
    return (
      <MenuForm menu={this.state.menu}
               intl={this.props.intl}
               listUrl={"/menus"}
               history={this.props.history}
               updateRequest={this.props.updateRequest}
               createRequest={this.props.createRequest}/>
    )
  };
  
  render() {
    return (
      <Fragment>
        {this.getContent()}
      </Fragment>
    )
  }
}



const mapStateToProps = ({menus}: ApplicationState) => ({
  loading: menus.loading,
  errors: menus.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(MenuFormPage));



